import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { BannerFormTemplate } from '@/features/banner-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/banners/create/')({
  component: BannerCreatePage,
});

/** Página de criação de Banner. */
export function BannerCreatePage() {
  const { t } = useTranslation('banner');
  const navigate = useNavigate();

  const goToList = () => void navigate({ to: '/banners' });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('banner.form.createTitle')}
        subtitle={t('banner.form.pageHint')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/banners">{t('banner.breadcrumb.banners')}</Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('banner.breadcrumb.create')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {/* Criar termina na listagem; a edição é que permanece na tela ao salvar. */}
      <BannerFormTemplate banner={null} langs={[]} onCancel={goToList} onCreated={goToList} />
    </div>
  );
}
